<template>
  <div class="trend-chart">
    <div class="title">
      Trend Chart
    </div>
    <div class="options" :style="{ 'flex-direction': !isDesktop && 'column' }">
      <a-select
        v-model:value="query.type"
        :style="{ 'margin-bottom': !isDesktop && '10px', width: '170px' }"
        @change="getData"
      >
        <a-select-option
          v-for="item in chartOptions"
          :key="item.value"
          :value="item.value"
        >
          {{ item.label }}
        </a-select-option>
      </a-select>
      <LastXDays
        v-model:value="query.queryTime"
        @get-data="getData"
      ></LastXDays>
    </div>
    <a-spin :spinning="spinning">
      <div ref="trendChart" id="chart"></div>
    </a-spin>
  </div>
</template>

<script>
import LastXDays from '@/components/LastXDays'
import { chartOptions } from '@/utils/database'
import echarts from 'echarts'
import moment from 'moment'

const YMD = 'YYYY-MM-DD'
const MD = 'MM-DD'

const chartTheme = require('@/styles/chart_theme/macarons.json')
let chart = undefined

export default {
  name: 'TrendChart',
  components: { LastXDays },
  created() {
    this.getData()
  },
  computed: {
    isDesktop() {
      return this.$store.state.app.device === 'desktop'
    },
  },
  data() {
    return {
      query: {
        queryTime: 7,
        type: 1,
      },
      chartOptions,
      chartData: [],
      spinning: false,
    }
  },
  methods: {
    getData() {
      this.spinning = !this.spinning
      this.$store
        .dispatch('user/GetTrendingChart', this.query)
        .then((res) => {
          this.chartData = res || []
          this.initChart()
        })
        .finally(() => {
          this.spinning = !this.spinning
        })
    },
    initChart() {
      echarts.registerTheme('macarons', chartTheme)
      chart = echarts.init(this.$refs.trendChart, 'macarons')
      // this.chart = echarts.init(document.getElementById('chart'))
      this.setOptions(this.chartData)
    },
    setOptions(data) {
      let xData = []
      let yData = []
      for (let i = this.query.queryTime; i > 0; i--) {
        const dateString = moment()
          .subtract(i, 'days')
          .format(YMD)
        xData.push(moment(dateString).format(MD))
        let value = data.find((item) => dateString === item.dateString)
        yData.push(value ? value.value : 0)
      }
      chart.setOption(
        {
          tooltip: {
            trigger: 'axis',
          },
          xAxis: {
            type: 'category',
            data: xData,
          },
          yAxis: {
            type: 'value',
            minInterval: 1,
          },
          series: [
            {
              data: yData,
              type: 'line',
              smooth: true,
            },
          ],
        },
        true,
      )
    },
  },
}
</script>

<style lang="scss" scoped>
.trend-chart {
  padding: 20px;
  // width: 490px;
  height: 370px;
  background-color: #fff;
  text-align: left;
  border-radius: 4px;

  .title {
    font-size: 20px;
  }

  .options {
    margin-top: 15px;
    display: flex;
    justify-content: space-between;
  }

  #chart {
    width: 100%;
    height: 250px;
    // margin: auto auto;
  }
}
</style>
